import { HttpInterceptors } from "./http.interceptor";

export class TaxeService extends HttpInterceptors {
	async listTaxe (filters) {
		const response = await this.axios.get("taxe/listTaxe", { params: { filters } });
		return response.data;
	}

	async upsertTaxe (payload) {
		const response = await this.axios.post("taxe/upsertTaxe", payload);
		return response.data;
	}

	async deleteTaxe (id) {
		const response = await this.axios.delete("taxe/deleteTaxe", { params: id });
		return response.data;
	}
}
